export default __webpack_public_path__ + "static/media/img-added.29037860.svg";